// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__XKlDa","rightAdornment":"Header_rightAdornment__2Tyui"};